export const RELATORIO_LAUDO_SELECIONADO = 'RELATORIO_LAUDO_SELECIONADO';
export const laudoSelecionado = (laudoSelecionado) => ({
  type: RELATORIO_LAUDO_SELECIONADO,
  payload: {
    laudoSelecionado,
  },
});




// WEBPACK FOOTER //
// ./src/pages/relatorio/relatorio.action.js